// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading___ferr","full_screen":"Loading_full_screen__2S_Ig","Loader":"Loading_Loader__1qYFo","SLifeLoad8":"Loading_SLifeLoad8__1YQks"};